export default {
    id: "9511d368-d36e-449c-82cc-be3e9323cb0c",
    icon: "mdi-card-text-outline",
    name: "textarea",
    title: "Text Area",
    description: "A block textarea",
}